import React, { useEffect, useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { formatPrice } from '../../utils';
import { useCart } from '../../contexts/CartContext';
import { DEFAULT_CURRENCY, cartItemToDataLayerItem, getDataLayerValue, pushDataLayerEvent } from '../../utils/dataLayer';
import IconButton from '../SVGs/IconButton';
import Image from '../Image';

const CartItem = ({ item }) => {

  const { removeFromCart, updateCartItem  } = useCart();

  const [cartItemQty, setCartItemQty] = useState(item.quantity)

  const key = item?.key ?? item.variation_id

  // increment qty
  const incrementQty = () => {
    setCartItemQty(prevQuantity => prevQuantity + 1);
  }

  // decrement qty
  const decrementQty = () => {
    setCartItemQty(prevQuantity => (prevQuantity > 1 ? prevQuantity - 1 : 1));
  }

  useEffect(()=> {
    updateCartItem(key, cartItemQty);
  },[cartItemQty])

  useEffect(() => {
    setCartItemQty(item.quantity);
  }, [item.quantity]);

  const image = getImage(item.image)

  const handleRemoveFromCart = () => {
    const dataLayerItem = cartItemToDataLayerItem(item);

    pushDataLayerEvent('remove_from_cart', {
      currency: DEFAULT_CURRENCY,
      value: getDataLayerValue([dataLayerItem]),
      items: [dataLayerItem],
    });

    removeFromCart(item.variation_id);
  }

  return (
    <div className='pt-10 pb-4 border-b border-solid border-dnd-darker-grey space-y-4 lg:space-y-5'>
      <div className="flex">
        <div className='mr-6 w-16 h-[107px]'>
          <Image image={item.image} alt={item.name} className='!w-full !h-full' />
        </div>

        <div className='space-y-4'>
          <div>
            <h4 className='font-benguiat font-normal text-white text-_2429'>{item.name}</h4>
            <h5 className='text-white'>{item.variation}</h5>
            <h5 className='text-white'>QTY: {cartItemQty}</h5>
          </div>

          <div className='flex font-inter gap-x-3'>
            <button onClick={decrementQty} className='text-white font-medium text-_1822'>-</button>
            <p className='text-white font-medium text-_1822'>{cartItemQty}</p>
            <button onClick={incrementQty} className='text-white font-medium text-_1822'>+</button>
          </div>
        </div>
        
        <div className='flex flex-col justify-between items-end ml-auto'>
          <div>
            <IconButton 
              icon='trash'
              iconColor='#FFA200'
              backgroundColor='transparent'
              hoverTextColor='#FF0000'
              size='md'
              onClick={handleRemoveFromCart}
            />
          </div>

          <div className='flex gap-2.5 flex-wrap justify-end'>
            { item.sale_price ? (
              <>
                <p className='text-dnd-red font-inter line-through font-medium text-_1822'>{formatPrice(item?.regular_price)}</p>
                <p className='text-white font-inter font-medium text-_1822'>{formatPrice(item.price)}</p>
              </>
            ): (
              <p className='text-white font-inter font-medium text-_1822'>{formatPrice(item.price)}</p>
            )}
          </div>
        </div>
      </div>
      
      <div>
          <h4 className='text-dnd-yellow font-benguiat font-normal text-_1619'>{item.hashtag}</h4>
      </div>
    </div>
  )
}

export default CartItem
